enum FRIENDS_AND_ENEMIES_PARAMS {
    DAO_SCORE = 'coVoterDaoScore',
    NAME = 'name',
    FRIENDLY_VOTES = 'friendlyVotes',
    HOSTILE_VOTES = 'hostileVotes',
}

export { FRIENDS_AND_ENEMIES_PARAMS };
